export const summary = [
  {
    name: 'Overall',
    url: '/summary/',
    icon: 'icon-home'
  }
];
